//
import { date, required } from '@/services/validations'
import UserModel from '@/models/General/GUser'
import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'

//
import DispatchRequestFilters from '@/views/Warehouse/WhDispatchRequest/list/filters'
import DispatchRequestHeaders from '@/views/Warehouse/WhDispatchRequest/list/headers'

//
import DetailDispatchRequestBatchHeaders from '@/views/Warehouse/WhDispatchRequestBatch/update/headers'

//
export default ({ can_edit }) => [
    {
        name: 'supervisor_g_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'dispatch_date',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            fieldProps: {
                rules: [date, required],
            },
            pickerProps: {
                readonly: !can_edit,
            },
            label: 'Despacho',
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'zone',
        type: 'text-field',
        props: {
            label: 'Zona',
            rules: [required],
        },
    },
    {
        name: 'wh_selected_dispatch_request_batch',
        type: 'data-table-model',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DetailDispatchRequestBatchHeaders,
            noActions: true,
            noDataText: 'Sin solicitudes de despacho.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noRefresh: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                filters: DispatchRequestFilters,
                headers: DispatchRequestHeaders,
                mapper: row => {
                    //
                    row.observation = ''
                    //
                    return row
                },
                initialFilterValues: {
                    g_state_id: 24, // solo solicitudes de abastecimiento confirmadas
                },
                submitText: 'confirmar selección',
                service: DispatchRequestModel,
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle:
                'Lista de solicitudes de despacho incluidas en el lote',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            readonly: !can_edit,
            rules: [required],
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            noDataText: 'Sin empleados.',
            label: 'Descripción',
            rules: [required],
        },
    },
    {
        name: 'wh_detail_dispatch_requests_total',
        type: 'currency-field',
        props: {
            label: 'Total transportado'
        }
    }
]
